import RegionSelector from "../../../../components/RegionSelector";
import useColors from "../../../../customHooks/useColors";



const MyRewardsLeftSide = ({ setSelectedRegion, rewardRegions }) => {
  ///////////////////////////////////////////////////////////////////////////////////// REDUX
  const [currentColors] = useColors();


  /////////////////////////////////////////////////////////////////////////////////////REDUX STATE DRIVEN VARIABLES

  

  ///////////////////////////////////////////////////////////////////////////////////// BOOTSTRAP


  ///////////////////////////////////////////////////////////////////////////////////// STYLE
  const styles = {
    mainDiv: {
      backgroundColor: currentColors.quinary,
    },
  };

  /////////////////////////////////////////////////////////////////////////////////////RENDER
  return (
    <>
      <div style={styles.userInfoContainer}>
      </div>
      <RegionSelector
        data={rewardRegions}
        setSelectedRegion={setSelectedRegion}
      />
    </>
  );
};

export default MyRewardsLeftSide;
